import { useQuery } from '@tanstack/react-query';
import { validatedApi } from '../../../lib/api/validated-client';

export interface CancellationPreview {
  bookingId: string;
  refundAmount: number;
  refundPercentage: number;
  reason: string;
  policyMessage: string;
}

/**
 * Hook to fetch cancellation preview for a booking
 * Shows refund amount and policy before confirming cancellation
 */
export function useCancellationPreview(bookingId: string | null) {
  return useQuery<CancellationPreview | null>({
    queryKey: ['booking', bookingId, 'cancellation-preview'],
    queryFn: async () => {
      if (!bookingId) return null;
      return validatedApi.get<CancellationPreview>(`/bookings/${bookingId}/cancellation-preview`);
    },
    enabled: !!bookingId,
  });
}
